import { jsx as _jsx } from "react/jsx-runtime";
import { formatConnectorName, isConnectorId, } from '#pplx/frontend/apps/ask/files/file-utils/fileUtils.js';
import { CORE_SOURCES, isCoreSourceType, } from '#pplx/frontend/apps/ask/sources/coreSourcesConfig.js';
import { getCometMcpServerName, isCometMcpSourceType, } from '#pplx/frontend/apps/ask/sources/types/cometMcpSourceTypes.js';
import { getAvatarSizeForIconSize } from '#pplx/frontend/apps/ask/sources/utilities/getAvatarSizeForIconSize.js';
import { BMJ_AVATAR, BMJ_FORMATTED_NAME, NEJM_AVATAR, NEJM_FORMATTED_NAME, } from '#pplx/frontend/branded-sources/consts.js';
import Avatar from '#pplx/frontend/components/user/Avatar.js';
import { getConnectorAvatar } from '#pplx/frontend/components/utils/connectors.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
// TODO(ENT-5690): Vespa-backed premium sources (NEJM, BMJ) are static enum
// members with no DDB Source row, so `useApiSource.getIcon` can't supply
// their avatar. Hardcode here until each source has a DDB row with `icon_url`,
// at which point this map and the `VESPA_PREMIUM_AVATARS` branch below should
// be deleted.
const VESPA_PREMIUM_AVATARS = {
    nejm: { avatar: NEJM_AVATAR, name: NEJM_FORMATTED_NAME },
    bmj: { avatar: BMJ_AVATAR, name: BMJ_FORMATTED_NAME },
};
/**
 * @deprecated use getSourceIcon from useSources instead
 */
export const useSourceIcon = ({ cometMcpSources }) => {
    const intl = useIntl();
    const getSourceIcon = useCallback((sourceType, size = 'default') => {
        if (isCoreSourceType(sourceType)) {
            return {
                type: 'sprite',
                icon: CORE_SOURCES[sourceType].icon,
            };
        }
        const vespaPremium = VESPA_PREMIUM_AVATARS[sourceType];
        if (vespaPremium) {
            return {
                type: 'custom',
                icon: (_jsx(Avatar, { user: vespaPremium.avatar, size: getAvatarSizeForIconSize(size), rounded: false, showBackground: false, altText: intl.formatMessage({
                        id: '76863dae25',
                        defaultMessage: '{name} logo',
                        description: 'Alt text for connector logo image',
                    }, { name: vespaPremium.name }) })),
            };
        }
        if (isConnectorId(sourceType)) {
            const icon = getConnectorIcon(sourceType, intl, size);
            if (!icon) {
                return { type: 'sprite', icon: $icon('plug') };
            }
            return { type: 'custom', icon };
        }
        if (isCometMcpSourceType(sourceType)) {
            const serverName = getCometMcpServerName(sourceType);
            const avatar = cometMcpSources[serverName]?.avatar;
            if (!avatar)
                return undefined;
            return { type: 'custom', icon: avatar };
        }
        return undefined;
    }, [intl, cometMcpSources]);
    return getSourceIcon;
};
function getConnectorIcon(connectorId, intl, size) {
    const connectorAvatar = getConnectorAvatar(connectorId);
    if (!connectorAvatar) {
        return undefined;
    }
    const connectorName = formatConnectorName(connectorId);
    const altText = intl.formatMessage({
        id: '76863dae25',
        defaultMessage: '{name} logo',
        description: 'Alt text for connector logo image',
    }, { name: connectorName });
    return (_jsx(Avatar, { user: connectorAvatar, size: getAvatarSizeForIconSize(size), rounded: false, showBackground: false, altText: altText }));
}
//# sourceMappingURL=useSourceIcon.js.map